<template>
  <div class="face" >
    <el-divider content-position="left">实名认证</el-divider>
    <el-row>
      <el-col :span="8">
        <el-button type="primary" size="mini" @click="handleAddOpen">录入信息</el-button>
      </el-col>
      <el-col :span="8" :offset="8">
        <el-input v-model="search" size="mini" placeholder="输入手机号搜索" />
      </el-col>
    </el-row>
    <el-table :data="pageData" size="medium" style="width: 100%">
      <el-table-column v-for="(item, index) in col"
      :key="index"
      :prop="item.prop"
      :label="item.label">
      </el-table-column>
      <el-table-column label='验证'>
        <template slot-scope="scope">
          <el-link v-if="scope.row.verified === '未验证'" disabled>{{scope.row.verified}}</el-link>
          <el-link v-else-if="scope.row.verified === '验证失败'" type="danger" disabled>{{scope.row.verified}}</el-link>
          <el-link v-else-if="scope.row.verified === '已验证'" type="primary" @click="showVerifie(scope.$index, scope.row)">{{scope.row.verified}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label='录入时间'>
        <template slot-scope="scope">
          {{scope.row.created_at}}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="90">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    <el-dialog
      title="录入信息"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleAddClose">
      <div>
        <el-row>
          <el-input
            placeholder="请输入姓名"
            v-model="addData.name"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="请输入手机号"
            v-model="addData.phone"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="请输入订单号"
            v-model="addData.order_num"
            clearable>
          </el-input>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleAddClose">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑信息"
      :visible.sync="editDialogVisible"
      width="30%"
      :before-close="handleEditClose">
      <div>
        <el-row>
          <el-input
            placeholder="请输入姓名"
            v-model="saveData.name"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="请输入手机号"
            v-model="saveData.phone"
            clearable>
          </el-input>
        </el-row>
        <el-row>
          <el-input
            placeholder="请输入订单号"
            v-model="saveData.order_num"
            clearable>
          </el-input>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleEditClose">取 消</el-button>
        <el-button type="primary" size="mini" @click="handleSave">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer
      title="认证信息"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleDrawerClose"
      size="50%">
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="24">
            <el-card shadow="always">
              <div slot="header" class="clearfix">
                <span>OCR识别信息</span>
              </div>
              <div class="verified-box">
                <el-row>
                  <el-col :span="24"><span>姓名：{{verifiedInfo.ocr_name}}</span></el-col>
                </el-row>
                <el-row>
                  <el-col :span="8"><span>性别：{{verifiedInfo.ocr_gender}}</span></el-col>
                  <el-col :span="8"><span>民族：{{verifiedInfo.ocr_nation}}</span></el-col>
                </el-row>
                <el-row>
                  <el-col :span="24"><span>出生：{{verifiedInfo.ocr_birthday}}</span></el-col>
                </el-row>
                <el-row>
                  <el-col :span="24"><span>住址：{{verifiedInfo.ocr_address}}</span></el-col>
                </el-row>
                <el-row>
                  <el-col :span="24"><span>公民身份证号码：{{verifiedInfo.ocr_id_card_number}}</span></el-col>
                </el-row>
                <el-row>
                  <el-col :span="24"><span>签发机关：{{verifiedInfo.ocr_issue_authority}}</span></el-col>
                </el-row>
                <el-row>
                  <el-col :span="24"><span>有效期限：{{verifiedInfo.ocr_issue_time}}-{{verifiedInfo.ocr_expire_time}}</span></el-col>
                </el-row>
              </div>
              <div class="verified-img">
                <el-row>
                  <el-image
                    style="width: 120px; height: 150px"
                    :src="verifiedInfo.image"
                    :preview-src-list="verifiedInfo.srcList">
                  </el-image>
                </el-row>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-card shadow="always">
              <div slot="header" class="clearfix">
                <span>用户二次确认信息</span>
              </div>
              <el-row>
                <el-col :span="24"><span>姓名：{{verifiedInfo.confirm_name}}</span></el-col>
              </el-row>
              <el-row>
                <el-col :span="24"><span>身份证：{{verifiedInfo.idcard_number}}</span></el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-card shadow="always">
              <div slot="header" class="clearfix">
                <span>比对结果</span>
              </div>
              <el-row>
                <el-col :span="12"><span>活体检测分数：{{verifiedInfo.liveness_score}}</span></el-col>
                <el-col :span="12"><span>公安验证：{{verifiedInfo.score}}</span></el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'FaceVerified',
  data () {
    return {

      search: '',
      dialogVisible: false,
      editDialogVisible: false,
      drawer: false,
      faces: [],
      verifiedInfo: {
        image: '',
        srcList: [],
        ocr_name: '',
        ocr_nation: '',
        ocr_gender: '',
        ocr_birthday: '',
        ocr_address: '',
        ocr_id_card_number: '',
        ocr_issue_time: '',
        ocr_expire_time: '',
        ocr_issue_authority: '',
        liveness_score: '',
        score: '',
        confirm_name: '',
        idcard_number: ''
      },
      col: [
        {
          label: 'id',
          prop: 'id'
        },
        {
          label: '订单号',
          prop: 'order_num'
        },
        {
          label: '姓名',
          prop: 'name'
        },
        {
          label: '手机号',
          prop: 'phone'
        }
      ],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 10 // 每页显示条数
      },
      addData: {
        name: '',
        phone: '',
        order_num: ''
      },
      saveData: {
        index: null,
        id: 0,
        name: '',
        order_num: '',
        phone: ''
      }
    }
  },
  computed: {
    pageData: {
      get: function () {
        return this.faces.filter(data => !this.search || data.phone.toLowerCase().includes(this.search.toLowerCase())).slice(this.pageOption.pageSize * (this.pageOption.currentPage - 1), this.pageOption.pageSize * this.pageOption.currentPage)
      }
    },
    collapse () {
      return this.$store.state.collapse
    }
  },
  watch: {
    search: function () {
      this.pageOption.total = this.search ? this.searchTotal() : this.faces.length
    }
  },
  methods: {
    searchTotal () {
      return this.faces.filter(data => !this.search || data.phone.toLowerCase().includes(this.search.toLowerCase())).length
    },
    handleGetFaces () {
      this.$axios.get('/api/admin/faces')
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.faces = data.data.faces
            this.pageOption.total = this.faces.length
          }
        })
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
    },
    handleAddOpen () {
      this.dialogVisible = true
    },
    handleAdd () {
      if (!this.addData.name) {
        this.$message.error('姓名不能为空！')
        return
      }

      if (!this.addData.phone) {
        this.$message.error('手机号不能为空')
        return
      }

      this.$axios.post('/api/admin/faces', this.addData)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.faces.unshift(data.data)
            this.pageOption.total = this.faces.length
            this.$message.success(data.msg)
            this.handleAddClose()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleAddClose () {
      this.addData.name = ''
      this.addData.phone = ''
      this.addData.order_num = ''
      this.dialogVisible = false
    },
    showVerifie (index, row) {
      this.verifiedInfo.ocr_name = row.ocr_name
      this.verifiedInfo.ocr_nation = row.ocr_nation
      this.verifiedInfo.ocr_gender = row.ocr_gender
      this.verifiedInfo.ocr_birthday = row.ocr_birthday
      this.verifiedInfo.ocr_address = row.ocr_address
      this.verifiedInfo.ocr_id_card_number = row.ocr_id_card_number
      this.verifiedInfo.ocr_issue_time = row.ocr_issue_time
      this.verifiedInfo.ocr_expire_time = row.ocr_expire_time
      this.verifiedInfo.ocr_issue_authority = row.ocr_issue_authority
      this.verifiedInfo.liveness_score = row.liveness_score
      this.verifiedInfo.score = row.score
      this.verifiedInfo.confirm_name = row.confirm_name
      this.verifiedInfo.idcard_number = row.idcard_number
      this.verifiedInfo.image = row.verify_image
      this.verifiedInfo.srcList.push(row.verify_image)
      this.drawer = true
    },
    handleDrawerClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.clearVerified()
          done()
        })
        .catch(_ => {})
    },
    clearVerified () {
      this.verifiedInfo.ocr_name = ''
      this.verifiedInfo.ocr_nation = ''
      this.verifiedInfo.ocr_gender = ''
      this.verifiedInfo.ocr_birthday = ''
      this.verifiedInfo.ocr_address = ''
      this.verifiedInfo.ocr_id_card_number = ''
      this.verifiedInfo.ocr_issue_time = ''
      this.verifiedInfo.ocr_expire_time = ''
      this.verifiedInfo.ocr_issue_authority = ''
      this.verifiedInfo.liveness_score = ''
      this.verifiedInfo.score = ''
      this.verifiedInfo.confirm_name = ''
      this.verifiedInfo.idcard_number = ''
      this.verifiedInfo.image = ''
      this.verifiedInfo.srcList = []
    },
    handleEdit (index, row) {
      this.saveData.index = index
      this.saveData.id = row.id
      this.saveData.name = row.name
      this.saveData.phone = row.phone
      this.saveData.order_num = row.order_num
      this.editDialogVisible = true
    },
    handleEditClose () {
      this.saveData.index = null
      this.saveData.id = 0
      this.saveData.name = ''
      this.saveData.phone = ''
      this.saveData.order_num = ''
      this.editDialogVisible = false
    },
    handleSave () {
      if (!this.saveData.name) {
        this.$message.error('姓名不能为空！')
        return
      }

      if (!this.saveData.phone) {
        this.$message.error('手机号不能为空')
        return
      }

      this.$axios.put('/api/admin/faces/' + this.saveData.id, this.saveData)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            let index = this.pageOption.pageSize * (this.pageOption.currentPage - 1) + this.saveData.index
            this.faces[index].name = this.saveData.name
            this.faces[index].phone = this.saveData.phone
            this.faces[index].order_num = this.saveData.order_num
            this.$message.success(data.msg)
            this.handleEditClose()
          } else {
            this.$message.error(data.msg)
          }
        })
    }
  },
  mounted () {
    this.handleGetFaces()
  }
}
</script>

<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  @import '~styles/vertical.styl'
  .face
    marginLeft()
  .clearfix:before,
  .clearfix:after
    display: table
    content: ""
  .clearfix:after
    clear: both
  .el-row
    margin-bottom: .2rem
  .m-tabs-content
    padding: 0 .2rem 0 .4rem
    .el-row
      margin-bottom: .4rem
  .el-card >>> .el-card__header
    padding: .2rem .4rem
  .verified-box
    width: 60%
    display: inline-block
  .verified-img
    position: absolute
    right: .4rem
    width: 40%
    display: inline-block
    text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/face_verified/FaceVerified.vue